module.exports = __webpack_public_path__ + "media/application/images/icons/user-88cdb2c71668a8ef371f51967003ab93.svg";